// extracted by mini-css-extract-plugin
module.exports = {"content":"materials_content__wNJf5","center":"materials_center__1Hpn8"};